import { JustificationUpdateForm } from 'components/Pages/ReverseLogistics/Configuration/Justifications';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const JustificationUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/logistica-reversa/justificativas');
  }, [navigate]);

  return (
    <Scaffold>
      <JustificationUpdateForm justificationId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
